export const BREAKPOINT_MOBILE_PIXELS: number = 450;
export const BREAKPOINT_MEDIUM_PIXELS: number = 768;
